import React, { useState, useEffect, useCallback } from "react";
import { ATC_URL } from '../../data/config';

const ATC = ({ map }) => {
  const [isVisible, setIsVisible] = useState(() => {
    return JSON.parse(localStorage.getItem("atcVisible")) === true;
  });
  const [activeAreas, setActiveAreas] = useState([]);

  const updateMapLayer = useCallback(() => {
    
    if (!map || !isVisible) return;

    try {
      if (!map.getLayer('lower-airspace')) return;

      console.log("Updating ATC highlights");

      let lineWidthExpression = 1;
      let lineColorExpression = '#9e9e9e';

      if (activeAreas.length > 0) {
        lineWidthExpression = [
          'case',
          ...activeAreas.flatMap(area => [
            ['==', ['get', 'name'], area], 2.2
          ]),
          1
        ];

        lineColorExpression = [
          'case',
          ...activeAreas.flatMap(area => [
            ['==', ['get', 'name'], area], '#767676'
          ]),
          '#9e9e9e'
        ];
      }

      map.setPaintProperty('lower-airspace', 'line-width', lineWidthExpression);
      map.setPaintProperty('lower-airspace', 'line-color', lineColorExpression);

    } catch (error) {
      console.error("Error updating ATC layer:", error);
    }
  }, [map, activeAreas, isVisible]);

  const fetchATCData = useCallback(async () => {
    try {
      const response = await fetch(ATC_URL);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();

      const areas = data.flatMap(atc => (atc.aor ? atc.aor.map(area => area.areaname) : []));
      
      setActiveAreas(areas);

    } catch (error) {
      console.error("Failed fetching ATC data:", error);
      setActiveAreas([]);
    }
  }, []);

  useEffect(() => {
    if (isVisible) {
      fetchATCData();
      const intervalId = setInterval(fetchATCData, 20 * 1000);
      return () => clearInterval(intervalId);
    }
  }, [isVisible, fetchATCData]);

  useEffect(() => {
    if (isVisible) {
      updateMapLayer();
    }
  }, [activeAreas, updateMapLayer]);
  

  const toggleVisibility = () => {
    setIsVisible(prev => {
      const newVisibility = !prev;
      localStorage.setItem("atcVisible", JSON.stringify(newVisibility));

      if (!newVisibility && map && map.getLayer('lower-airspace')) {
        map.setPaintProperty('lower-airspace', 'line-width', 1);
        map.setPaintProperty('lower-airspace', 'line-color', '#c7c7c7');
      }

      return newVisibility;
    });
  };

  return (
    <button
      data-tooltip-id="map-buttons-tooltip"
      data-tooltip-content="Local ATC activity"
      className={`w-8 h-8 ${isVisible ? "bg-gray-600" : "bg-gray-400"} text-white flex items-center justify-center`}
      onClick={toggleVisibility}
    >
      <span role="img" aria-label="ATC" className="text-sm">ATC</span>
    </button>
  );
};

export default ATC;
